import { styled } from '@mui/material/styles';
import { Autocomplete, Box, Typography } from '@mui/material';

export const StyledAutocomplete = styled(Autocomplete)(({ theme }) => ({
  '& fieldset': {
    border: 'none',
  },
  '& .MuiAutocomplete-input': {
    height: '34px',
    padding: '1px !important',
  },
  '& .MuiAutocomplete-inputRoot': {
    padding: '0px !important',
    minHeight: '34px',
    borderRadius: '0',
    border: `1px solid ${theme.palette.gray.base}`,
  },
  '& .MuiAutocomplete-tag': {
    height: '24px',
    margin: '5px',
    borderRadius: '4px',
    backgroundColor: theme.palette.inputBorderColor,
    minWidth: '83px',
    color: theme.palette.base.black,
  },
  '& .MuiAutocomplete-popupIndicatorOpen': {
    transform: 'rotate(0deg)',
  },
}));

export const autocompleteSlotProps = (theme) => ({
  paper: {
    sx: {
      borderRadius: '0px',
      boxShadow: `1px 3px 4px 0px ${theme.palette.shadows.shadowBlack}`,
    },
  },
  listbox: {
    sx: {
      padding: '0px',
      borderRadius: '0px',
      '& .MuiAutocomplete-option': {
        minHeight: '32px !important',
        height: '32px',
        padding: '0px !important',
      },
    },
  },
});

export const OptionContainer = styled(Box)(({ disabled }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '0px 16px',
  height: '32px',
  width: '100%',
  color: 'var(--prs-c-primary)',
  boxSizing: 'border-box',
  gap: '8px',
  ...(disabled && {
    opacity: 0.5,
  }),
}));

export const OptionName = styled(Typography)({
  fontSize: '16px',
  lineHeight: '1.2',
});

export const OptionGroup = styled(Typography)(({ groupOptionWidth }) => ({
  fontSize: '14px',
  fontStyle: 'italic',
  textAlign: 'right',
  paddingRight: '1px',
  lineHeight: '1.2',
  ...(groupOptionWidth && {
    width: '50%',
  }),
}));

export const CloseIconRoot = styled('span')(({ theme }) => ({
  '& svg': {
    width: '12px',
    height: '12px',
    fill: theme.palette.gray.dark,
  },
}));

export const OptionTextContainer = styled(Box)(({ groupOptionWidth }) => ({
  display: 'flex',
  ...(groupOptionWidth && {
    width: '50%',
  }),
}));

export const DisabledIcon = styled('span')({
  '& svg': {
    width: '14px',
    height: '14px',
  },
});

export const DisabledIconContainer = styled(Box)({
  paddingLeft: '8px',
});

export const SearchInputLabelContainer = styled(Box)({
  padding: '16px 0 8px 0',
});

export const SearchInputLabel = styled('label')({
  fontSize: '14px',
  fontWeight: 600,
  lineHeight: '22px',
});
